const formatMoney = {
    install(Vue) {
        Vue.filter('formatMoney', (value) => {
            let val = (value / 100).toFixed(2).toString().replace('.', ',')
            return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        });
    },
};

export default formatMoney